class ShowMoreContent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.dataIndex = parseInt(this.getAttribute("data-current"));
    this.dataMax = parseInt(this.getAttribute("data-max"));

    if (this.dataMax >= this.dataIndex) {
      document.querySelector('.description-split[data-index="' + this.dataIndex + '"]').classList.add("opening");
      this.setAttribute("data-current", this.dataIndex + 1);
      if (this.dataMax == this.dataIndex) {
        this.innerHTML = "Read less";
      }
    } else {
      document.querySelectorAll(".description-split").forEach((ele) => ele.classList.remove("opening"));
      document.querySelector('.description-split[data-index="1"]').classList.add("opening");
      this.innerHTML = "Read more";
      this.setAttribute("data-current", 2);
    }
  }
}

customElements.define("showmore-content", ShowMoreContent);